import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate'
import itOriginalMessages from 'vee-validate/dist/locale/it'

Vue.use(VueAxios, axios)

Vue.use(VeeValidate, {
	locale: 'it',
	dictionary: {
		it: itOriginalMessages,
	}
})

VeeValidate.Validator.extend('server', {
	getMessage: (field, params, data) => {
		return data.message
	},	
	validate: (value, params) => {
		return axios.post('validate/', 
			{
				model: params[0],
				rules: params[1],
				field: params[2],
				id: params[3] ? params[3] : null,
				value: value
			}).then((response) => {
			// Notice that we return an object containing both a valid property and a data property.
			if(response.data.valid == false) {
				return {
					valid: false,
					data: {
						message: response.data.data
					}
				}
			} else {
				return {valid: true}
			}

		})
	},
})
VeeValidate.Validator.extend('server-document', {
	getMessage: (field, params, data) => {
		return data.message
	},	
	validate: (value, params) => {
		let inputs = {}
		inputs.model = params[0]
		inputs.number = params[2] ? parseInt(params[2]) : null
		inputs.sectional_id = params[3] ? parseInt(params[3]) : null
		inputs.date = params[4] ? params[4] : null
		if(params[5]) {
			inputs.id = params[5] ? parseInt(params[5]) : null
		}

		if(isNaN(inputs.number) || isNaN(inputs.sectional_id) || !inputs.date) {
			return {valid: true}
		}

		return axios.post('validate-document/', inputs).then((response) => {
			// Notice that we return an object containing both a valid property and a data property.
			if(response.data.valid == false) {
				return {
					valid: false,
					data: {
						message: response.data.data
					}
				}
			} else {
				return {valid: true}
			}

		})
	},
})

VeeValidate.Validator.extend('is_time', {
	getMessage: field => 'Il formato deve essere HH:MM',
	validate: (value) => new Promise(resolve => {
		let regex = new RegExp('([0-1][0-9]|2[0-3]):([0-5][0-9])')
		resolve({
			valid: value && regex.test(value)
		})
	}),
})

VeeValidate.Validator.extend('is_correct_minutes', {
	getMessage: field => 'I minuti non sono corretti',
	validate: (value) => new Promise(resolve => {
		let regex = new RegExp(':([0-5][0-9])')
		resolve({
			valid: value && regex.test(value)
		})
	})
})

VeeValidate.Validator.extend('vat_code', {
	getMessage: field => 'Il formato della partita iva non è corretto',
	validate: (value, params) => new Promise(resolve => {
		// vat_zone = Estero
		if(typeof params[0] !== 'undefined' && params[0] == 3) {
			resolve({
				valid: true
			})
		} else {
			resolve({
				valid: value && Vue.validateVatCode(value)
			})
		}
	})
})

VeeValidate.Validator.extend('tax_code', {
	getMessage: field => 'Il formato del codice fiscale non è corretto',
	validate: (value) => new Promise(resolve => {
		resolve({
			valid: value && (Vue.validateTaxCode(value) || Vue.validateVatCode(value))
		})
	})
})

VeeValidate.Validator.extend('dimension_mediumtext', {
	getMessage: field => 'Il contenuto è troppo lungo',
	validate: (value) => new Promise(resolve => {
		let encoder = new TextEncoder()
		var byteLength = encoder.encode(value).length
		resolve({
			valid: byteLength < 8000000
		})
	})
})

VeeValidate.Validator.extend('dimension_text', {
	getMessage: field => 'Il contenuto è troppo lungo',
	validate: (value) => new Promise(resolve => {
		let encoder = new TextEncoder()
		var byteLength = encoder.encode(value).length
		resolve({
			valid: byteLength < 50000
		})
	})
})

VeeValidate.Validator.extend('date_min', {
	getMessage: (field, params) => `La data non può essere precedente al ${params[0].split('-').reverse().join('/')}`,
	validate: (value, params) => {
		if (!value || !params[0]) return true
		let parts = value.split('/')
		if (parts.length !== 3) return true
		let parsed = `${parts[2]}-${parts[1]}-${parts[0]}`
		return parsed >= params[0]
	}
})

VeeValidate.Validator.extend('date_max', {
	getMessage: (field, params) => `La data non può essere successiva al ${params[0].split('-').reverse().join('/')}`,
	validate: (value, params) => {
		if (!value || !params[0]) return true
		let parts = value.split('/')
		if (parts.length !== 3) return true
		let parsed = `${parts[2]}-${parts[1]}-${parts[0]}`
		return parsed <= params[0]
	}
})

